import { Pool } from "../../utils/Pool";
const className = "RestoreCmd";
export class RestoreCmd {
    static create() {
        return Pool.getItemByClass(className, RestoreCmd);
    }
    recover() {
        Pool.recover(className, this);
    }
    run(runner) {
        runner.restore();
    }
    get cmdID() {
        return RestoreCmd.ID;
    }
}
RestoreCmd.ID = className;
